import useSWR from 'swr';

import OpenFetcher from '../Components/Backend/OpenFetcher';
import { InstanceInfo } from '../Types/AuthServer';

export function useGetInstanceInfo() {
    const { data, mutate } = useSWR<InstanceInfo>('tasks/instance_info', OpenFetcher, {
        revalidateOnFocus: false,
        revalidateOnMount: false,
        revalidateOnReconnect: false,
        suspense: true,
    });

    return { instanceInfo: data!, mutate };
}
